import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    TextareaAutosize,
} from "@material-ui/core";
import React, { useState } from "react";

import { LogFilterRequest } from "../../../rest/requestObjects/eventLogRequest";
import { Event } from "../../../dtos/event";
import { useApi } from "../../useApi";

interface Props {
    open: boolean;
    onSuccess: () => void;
    onClose: () => void;
    siteId?: number | null;
    organizationId?: number | null;
    logFilterRequest?: LogFilterRequest;
    event?: Event;
}

export function AlarmAcknowledgementDialog({
    open,
    onSuccess,
    onClose,
    siteId,
    organizationId,
    logFilterRequest,
    event,
}: Props) {
    const { eventApi } = useApi();

    const [notes, setNotes] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNotes(e.currentTarget.value)
    };

    const handleSubmit = async () => {
        setIsLoading(true);

        if (logFilterRequest && siteId && organizationId) {
            await eventApi.acknowledgeEventsForSite({
                ...logFilterRequest,
                siteId,
                organizationId,
                notes,
            });
        }

        if (event) {
            await eventApi.acknowledgeEvent({
                ...event,
                acknowledged: true,
                notes,
            });
        }

        setIsLoading(false);
        setNotes("");
        onSuccess();
        onClose();
    };

    const handleCancel = () => {
        setNotes("");
        onClose();
    };

    return (
        <Dialog open={open}>
            <DialogTitle>
                Alarm Acknowledgement Notes
            </DialogTitle>

            <DialogContent>
                <TextareaAutosize
                    style={{ width: "90%" }}
                    value={notes}
                    rows={5}
                    onChange={handleNotesChange}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={isLoading}
                    onClick={handleSubmit}
                >
                    Submit
                </Button>

                <Button onClick={handleCancel}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}